// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, of, throwError } from 'rxjs';

// Helpers
import { isEmptyObject } from '../../lib/helpers/utils';

// Models
import { SearchIncrementType } from '../../models/b2b/searchIncrementType';
import { SearchOrderBy, SearchOrderByHelper } from '../../models/b2b/searchOrderBy';
import { SearchSettings, SearchSettingsHelper } from '../../models/b2b/searchSettings';
import { SearchTermOption, SearchTermOptionsHelper } from '../../models/b2b/searchTermOption';
import { User } from '../../models/b2b/user';

// Service
import { ApiService } from '../api/api.service';
import { SoledadUserService } from './user.service';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadSearchSettingsService {
    // pending operations
    private pendingConfiguration = false;

    constructor(private api: ApiService, private userService: SoledadUserService) {}

    /**
     * Load user settings
     * (updates observable searchSettings)
     */
    loadConfiguration(user: boolean): Observable<SearchSettings> {
        if (!user) {
            return of(null);
        }

        // User configuration
        return this.api.callSoledad('b2bNew.dbo.HTML_ConfiguracionLeer', []).pipe(
            validateApiResponse('Error obteniendo configuración'),
            map((res: any) => {
                return SearchSettingsHelper.transformFromApi(res[0], this.api.environment);
            })
        );
    }

    /**
     * Load available search's orderby options
     */
    loadSearchOrderByOptions(clienteCodigo: string): Observable<SearchOrderBy[]> {
        if (!clienteCodigo) {
            return of([]);
        }

        const params = [];
        params['CLIENTE'] = clienteCodigo;

        // User search orderby options
        return this.api.callSoledad('b2bNew.dbo.HTML_ArticulosBusquedaOrden', params).pipe(
            map((res) => {
                try {
                    if (isEmptyObject(res)) {
                        throw new Error('Error to obtain search orderBy options');
                    }
                    return res.value.map((row) => SearchOrderByHelper.transformFromApi(row));
                } catch (error) {
                    console.error(error);
                    throwError(error.message);
                }
            })
        );
    }

    /**
     * Load user's frequent search terms
     */
    loadUserFrequentSearchTerm(clienteCodigo: string): Observable<SearchTermOption[]> {
        if (!clienteCodigo) {
            return of(null);
        }

        const params = [];
        params['CLIENTE'] = clienteCodigo;

        // User's frequent search terms
        return this.api.callSoledad('b2bNew.dbo.HTML_MedidasMasBuscadas', params).pipe(
            map((res) => {
                try {
                    if (isEmptyObject(res)) {
                        throw new Error('Error to obtain settings');
                    }
                    return res.value.map((row) => SearchTermOptionsHelper.transformFromApi(row));
                } catch (error) {
                    console.error(error);
                    throwError(error.message);
                }
            })
        );
    }

    saveDefaultGiftAddress(defaultGiftAddress) {
        const params = [];
        params['DIRECCIONDEFECTO_REGALO'] = defaultGiftAddress;

        return this.api.callSoledad('b2bNew.dbo.HTML_ConfiguracionGrabar', params).pipe(
            map(
                (res) => {
                    // console.log('b2bNew.dbo.HTML_ConfiguracionGrabar', {res});
                    if (res && res.result === 0 && res.value && !res.value[0].ERROR) {
                        return true;
                    } else {
                        return false;
                    }
                },
                (error) => {
                    console.log({ error });
                }
            )
        );
    }
    saveSettings(settings: SearchSettings): Observable<boolean> {
        // console.log('settings recibidos: ', settings);

        const params = [];

        params['CONFIRMARPOREMAIL'] = settings.confirmacionEmail;
        // if ( 'actualizar_email' in  settings )  params['ACTUALIZAREMAIL'] = settings.actualizar_email;
        params['EMAILUSUARIO'] = settings.email;
        params['NOMBREEMAIL'] = settings.email_name;
        params['APELLIDOSEMAIL'] = settings.email_surname;
        // params['IDIOMA'] = 'Español'; // TODO Change to dynamic
        params['IDIOMA'] = settings.language;
        params['DIRECCIONDEFECTO'] = settings.address;
        if (typeof settings.defaultGiftAddress === 'number' && settings.defaultGiftAddress >= 0) {
            params['DIRECCIONDEFECTO_REGALO'] = settings.defaultGiftAddress;
        }
        params['MOSTRARPVR'] = settings.mostrarPVR;
        params['NUMEROREGISTROS'] = settings.numArticulos;
        params['NUMERORUEDAS'] = settings.numRuedas;
        params['CONSTOCK'] = settings.predetConStock ? 1 : 0;
        // params['ORDENBUSQUEDA'] = settings.ordenBusqueda;
        // params['OCULTARINCREMENTO'] = settings.ocultarIncremento ? 1 : 0;
        // params['FORMAPAGO'] = settings.formaPago;
        // params['CONFIRMARPORMOVIL'] = settings.confirmarPorMovil ? 1 : 0;
        params['INCREMENTO_CANTIDAD'] = settings.incremento_cantidad;
        params['INCREMENTO_TIPO'] = settings.incremento_tipo === SearchIncrementType.Value ? '€' : '%';

        params['TIPORESULTADOBUSQUEDA'] = settings.tipoResultadoBusqueda; // (AVANZADO/BASICO)
        params['MOSTRARCANTIDADBUSQUEDA'] = settings.mostrarCantidadBusqueda; // (true/false)
        params['EQUIVALENCIASPREDETERMINADO'] = settings.equivalenciasDefault; // (true/false)

        params['CONFIRMARPEDIDOSERVIDO'] = settings.confirmarPedidoServido;
        params['FILTROICCVSUPERIORES'] = settings.filtroICCVSuperiores;
        params['DIRECCIONDEFECTO_REGALO'] = settings.defaultGiftAddress;

        // console.log({params});

        return this.api.callSoledad('b2bNew.dbo.HTML_ConfiguracionGrabar', params).pipe(
            map(
                (res) => {
                    // console.log('b2bNew.dbo.HTML_ConfiguracionGrabar', {res});
                    if (res && res.result === 0 && res.value && !res.value[0].ERROR) {
                        return true;
                    } else {
                        return false;
                    }
                },
                (error) => {
                    console.log({ error });
                }
            )
        );
    }
}
